import React from 'react';
import Box from '@mui/material/Box';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material';

interface BaseLeftSideBarHeaderProps {
	isPinned: boolean;
	open: boolean;
	hoverOpen: () => void;
	hoverClose: () => void;
	toggleDrawer: () => void;
}

const BaseLeftSideBarHeader = ({ isPinned, open, hoverOpen, hoverClose, toggleDrawer }: BaseLeftSideBarHeaderProps) => {
	const themes = useTheme();
	return (
		<Box
			onMouseEnter={hoverOpen}
			onMouseLeave={hoverClose}
			sx={{
				height: '64px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: open ? 'space-between' : 'center',
				padding: !isPinned ? '8px 8px 8px 8px' : '8px 8px 8px 12px',
				background: `linear-gradient(90deg, #204321 0%, ${themes.palette.secondary.main} 64px) !important`
			}}
		>
			{open ? (
				<Box
					sx={{
						fontWeight: 'bold',
						fontSize: '18px',
						display: 'flex',
						alignItems: 'center',
						gap: 3
					}}
				>
					<Logo link />
					<IconButton onClick={toggleDrawer} sx={{ color: '#fff', padding: 0 }}>
						<MenuIcon />
					</IconButton>
				</Box>
			) : (
				<Box
					sx={{
						width: 64,
						height: 64,
						transition: themes.transitions.create(['width', 'height'], {
							duration: themes.transitions.duration.shortest,
							easing: themes.transitions.easing.easeInOut
						}),
						'& img': {
							width: '100%',
							height: '100%',
							objectFit: 'contain'
						}
					}}
				>
					<img src={`${process.env.PUBLIC_URL}/assets/images/logos/logo.svg`} alt="Shield Guard" />
				</Box>
			)}
		</Box>
	);
};

export default BaseLeftSideBarHeader;
